<template>
  <div class="marketing-root">
    <Header />
    <div class="map-container">
      <div class="center"><Spinner /></div>
      <LazyMap :fit="fit">
        <MapboxGeocoderControl />
        <mapbox-geolocate-control />
        <MapboxScaleControl />
        <MapCoursesLayer @click="clickCourses" />
        <MapboxPopup
          :key="popupLocation"
          v-if="highlit"
          :lng-lat="popupLocation"
        >
          <PopupCourseRow :course="item" v-for="item in highlit" />
        </MapboxPopup>
      </LazyMap>
    </div>
  </div>
</template>
<script setup lang="ts">
import { type MapMouseEvent } from "mapbox-gl";
import type { CoursesLayerItem } from "~/../shared/components/map/CoursesLayer.vue";

definePageMeta({ authenticated: false, layout: false });

const ipGeolocation = useIPGeolocation();

const highlit = ref();
const popupLocation = ref();

function clickCourses(e: MapMouseEvent, courses: CoursesLayerItem[]) {
  popupLocation.value = e.lngLat;
  highlit.value = courses;
}

const previewItem = ref();
</script>
<style scoped>
@import "~/assets/marketing-base.css";

.map-container {
  width: 100%;
  height: calc(100vh - var(--grid-3));
  display: grid;
  grid: auto / auto;
}

.center {
  display: grid;
  width: 100%;
  height: 100%;
  place-items: center;
}

.map-container > * {
  grid-area: 1/1/2/2;
}
</style>
